import {mapCallbackLogsToEvents} from './mappers/fromCallbackLogs'
import {mapCommandLogsToEvents} from './mappers/fromCommandLogs'
import {mapContentLifecycleToEvents} from './mappers/fromContentLifecycle'
import {mapMishapsToEvents} from './mappers/fromMishaps'
import {mapPrintJobsToEvents} from './mappers/fromPrintJobs'
import {sortEventsAscending} from './time'
import {PrintStoryDoc, PrintStoryEvent} from './types'

export const buildContentStoryEvents = ({
  content,
  codes = [],
  renderJobs = [],
  printJobs = [],
  mishaps = [],
  callbackLogs = [],
  commandLogs = [],
  includeSecondaryLogs = false,
}: {
  content?: PrintStoryDoc | null
  codes?: PrintStoryDoc[]
  renderJobs?: PrintStoryDoc[]
  printJobs?: PrintStoryDoc[]
  mishaps?: PrintStoryDoc[]
  callbackLogs?: PrintStoryDoc[]
  commandLogs?: PrintStoryDoc[]
  includeSecondaryLogs?: boolean
}): PrintStoryEvent[] => {
  const events: PrintStoryEvent[] = [
    ...mapContentLifecycleToEvents({content, codes, renderJobs}),
    ...mapPrintJobsToEvents(printJobs),
    ...mapMishapsToEvents(mishaps),
  ]

  if (includeSecondaryLogs) {
    events.push(...mapCallbackLogsToEvents(callbackLogs), ...mapCommandLogsToEvents(commandLogs))
  }

  return sortEventsAscending(events)
}
